<template>
    <v-container fluid class="container-full-bg-gray">
        <div>
        <app-modal-prompt
            v-model="createUserDialog"
            :loading="createUserLoading"
            @confirm="confirmCreateUser()"
            @cancel="cancelCreateUser()"
        >
            <template #title>
                Nuevo Usuario
            </template>
            <app-modal-container>
                <v-form ref="createUserDialogForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                            v-model="newUserValues.username"
                            label="Nombre de usuario"
                            prepend-inner-icon="mdi-account"
                            @keyup="usernameToLowerCase"
                            :rules="[validationRules.required, validationRules.notBlankSpace]"
                        />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="newUserValues.email"
                                label="Email"
                                prepend-inner-icon="mdi-email"
                                :rules="[validationRules.required, validationRules.emailFormat]"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="newUserValues.password"
                                counter
                                label="Contraseña"
                                prepend-inner-icon="mdi-lock-outline"
                                :hint="textPassMinLength"
                                :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace]"
                                :type="showPassCreateUserDialog ? 'text' : 'password'"
                                :append-icon="showPassCreateUserDialog ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassCreateUserDialog = !showPassCreateUserDialog"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="newUserValues.password_repeat"
                                counter
                                label="Repetir contraseña"
                                prepend-inner-icon="mdi-lock-outline"
                                :hint="textPassMinLength"
                                :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace, validationRules.createUserPassEqRepeat]"
                                :type="showPassCreateUserDialog2 ? 'text' : 'password'"
                                :append-icon="showPassCreateUserDialog2 ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassCreateUserDialog2 = !showPassCreateUserDialog2"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-select
                                v-model="newUserValues.friendship_kind"
                                filled
                                color="primary"
                                class="rounded-lg"
                                label="Rol"
                                item-text="name"
                                item-value="value"
                                prepend-inner-icon="mdi-account-hard-hat"
                                :items="modalPermission.items"
                                :rules="[validationRules.required]"
                                @change="onNewUserRoleChange"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox :disabled="newUserValues.friendship_kind == 'customer'" v-model="newUserValues.view_all_companies" class="modalCheckBox">
                                <template v-slot:label>
                                    {{textViewAllCompanies}}
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12" v-if="newUserValues.view_all_companies">
                            <app-select
                                v-model="newUserValues.default_role_kind"
                                filled
                                color="primary"
                                class="rounded-lg"
                                label="Permiso por defecto"
                                item-text="name"
                                item-value="value"
                                prepend-inner-icon="mdi-account-eye"
                                :items="defaultRoleKindSelectItems('create_user')"
                                :rules="[validationRules.requiredDefaultRoleKindCreate]"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="newUserValues.view_invoices" class="modalCheckBox"
                                :disabled="!permissionsAvailability.view_invoices.show">
                                <template v-slot:label>
                                    Acceso a facturas
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="newUserValues.view_banks" class="modalCheckBox"
                                :disabled="!permissionsAvailability.view_banks.show">
                                <template v-slot:label>
                                    Acceso a bancos
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="newUserValues.view_e_invoice" class="modalCheckBox"
                                :disabled="!permissionsAvailability.view_e_invoice.show">
                                <template v-slot:label>
                                    Acceso a factura electrónica
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="newUserValues.view_gestor" class="modalCheckBox"
                                :disabled="!permissionsAvailability.view_gestor.show">
                                <template v-slot:label>
                                    Acceso a gestor documental
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12" v-if="userData && userData.available_features && userData.available_features.feature_clock_in">
                            <v-checkbox v-model="newUserValues.view_working_hours" class="modalCheckBox"
                                :disabled="!permissionsAvailability.view_working_hours.show">
                                <template v-slot:label>
                                    Acceso a fichajes
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12" v-if="newUserValues.view_working_hours">
                            <v-divider class="mb-4"></v-divider>
                            <h3 class="mb-3">Horario de Trabajo</h3>
                            <app-text-field
                                v-model="newUserValues.work_schedule.nombre_jornada"
                                label="Nombre de la Jornada"
                                placeholder="Ej: Jornada Completa"
                                :rules="[validationRules.required]"
                            />
                            <app-text-field
                                v-model.number="newUserValues.work_schedule.vacation_days"
                                label="Días de Vacaciones al Año"
                                type="number"
                                placeholder="22"
                                hint="Número de días de vacaciones que tiene el usuario al año"
                                persistent-hint
                            />
                            <work-schedule-table
                                ref="scheduleTable"
                                v-model="newUserValues.work_schedule.horario_semanal"
                            ></work-schedule-table>
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
            
        </app-modal-prompt>

        <app-confirm-modal
            v-model="deleteUsersConfirmDialog"
            :text-msg="deleteUsersConfirmMsg"
            @confirm="confirmDeleteUsers()"
            @cancel="cancelDeleteUsers()"
        >
        </app-confirm-modal>

        <app-confirm-modal
            v-model="blockUserConfirmDialog"
            :text-msg="blockUserConfirmMsg"
            @confirm="confirmBlockUser()"
            @cancel="cancelBlockUser()"
        >
        </app-confirm-modal>

        <app-confirm-modal
            v-model="unblockUserConfirmDialog"
            :text-msg="unblockUserConfirmMsg"
            @confirm="confirmUnblockUser()"
            @cancel="cancelUnblockUser()"
        >
        </app-confirm-modal>

        <app-modal-prompt
            v-model="updateFiscalDataUserDialog"
            :loading="updateFiscalDataUserLoading"
            @confirm="confirmUpdateFiscalDataUserDialog()"
            @cancel="cancelUpdateFiscalDataUserDialog()"
        >
            <template #title>
                Datos Fiscales
            </template>
            <v-form ref="updateFiscalDataUserDialogForm">
                <app-modal-container>
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="updateFiscalDataUserValues.business_name"
                                label="Razón Social"
                                prepend-inner-icon="mdi-domain"                                
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="updateFiscalDataUserValues.business_id"
                                label="CIF"
                                prepend-inner-icon="mdi-card-account-details-outline"                                
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">                            
                            <app-text-field
                                v-model="updateFiscalDataUserValues.postal_address"
                                label="Dirección"                                
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">                            
                            <app-text-field
                                v-model="updateFiscalDataUserValues.post_code"
                                label="Código postal"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">                            
                            <app-text-field
                                v-model="updateFiscalDataUserValues.province"
                                label="Población"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </app-modal-container>
            </v-form>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="updateUserDialog"
            :loading="updateUserLoading"
            @confirm="confirmUpdateUserDialog()"
            @cancel="cancelUpdateUserDialog()"
        >
            <template #title>
                Actualizar Usuario
            </template>
            <v-form ref="updateUserDialogForm">
                <app-modal-container>
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="updateUserValues.userame"
                                label="Nombre de usuario"
                                prepend-inner-icon="mdi-account"
                                :disabled="true"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="updateUserValues.email"
                                label="Email"
                                prepend-inner-icon="mdi-email"
                                :rules="[validationRules.required, validationRules.emailFormat]"
                            />
                        </app-modal-col>
                    </app-modal-row>
                    <app-modal-row v-if="updateUserValues.kind">
                        <app-modal-col cols="12">
                            <app-select
                                v-model="updateUserValues.kind"
                                filled
                                color="primary"
                                class="rounded-lg"
                                label="Rol"
                                item-text="name"
                                item-value="value"
                                prepend-inner-icon="mdi-account-hard-hat"
                                :items="modalPermission.items"
                                :rules="[validationRules.required]"
                                @change="onUpdateUserRoleChange"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox :disabled="updateUserValues.kind == 'customer' && !updateUserValues.view_all_companies"v-model="updateUserValues.view_all_companies" class="modalCheckBox">
                                <template v-slot:label>
                                    {{textViewAllCompanies}}
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-select
                                v-if="updateUserValues.view_all_companies"
                                v-model="updateUserValues.default_role_kind"
                                filled
                                color="primary"
                                class="rounded-lg"
                                label="Permiso por defecto"
                                item-text="name"
                                item-value="value"
                                prepend-inner-icon="mdi-account-eye"
                                :items="defaultRoleKindSelectItems('update_user')"
                                :rules="[validationRules.requiredDefaultRoleKindUpdate]"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="updateUserValues.view_invoices" class="modalCheckBox"
                            :disabled="!permissionsAvailability.view_invoices.show">
                                <template v-slot:label>
                                    Acceso a facturas
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="updateUserValues.view_banks" class="modalCheckBox"
                            :disabled="!permissionsAvailability.view_banks.show">
                                <template v-slot:label>
                                    Acceso a bancos
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="updateUserValues.view_e_invoice" class="modalCheckBox"
                            :disabled="!permissionsAvailability.view_e_invoice.show">
                                <template v-slot:label>
                                    Activar acceso a factura electrónica
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-checkbox v-model="updateUserValues.view_gestor" class="modalCheckBox"
                            :disabled="!permissionsAvailability.view_gestor.show">
                                <template v-slot:label>
                                    Acceso a gestor documental
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                        <app-modal-col cols="12" v-if="userData && userData.available_features && userData.available_features.feature_clock_in">
                            <v-checkbox v-model="updateUserValues.view_working_hours" class="modalCheckBox"
                                :disabled="!permissionsAvailability.view_working_hours.show">
                                <template v-slot:label>
                                    Acceso a fichajes
                                </template>
                            </v-checkbox>
                        </app-modal-col>
                    </app-modal-row>
                </app-modal-container> 
            </v-form>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="changePassUserDialog"
            :loading="changePassLoading"
            @confirm="confirmChangePassUserDialog()"
            @cancel="cancelChangePassUserDialog()"
        >
            <template #title>
                Cambiar Contraseña
            </template>
            <v-form ref="changePassUserDialogForm">
                <app-modal-container>
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="newPassValues.password"
                                counter
                                label="Nueva contraseña"
                                prepend-inner-icon="mdi-lock-outline"
                                :hint="textPassMinLength"
                                :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace]"
                                :type="showPassChangePass ? 'text' : 'password'"
                                :append-icon="showPassChangePass ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassChangePass = !showPassChangePass"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="newPassValues.password_repeat"
                                counter
                                label="Repetir nueva contraseña"
                                prepend-inner-icon="mdi-lock-outline"
                                :hint="textPassMinLength"
                                :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace, validationRules.changePassEqRepeat]"
                                :type="showPassChangePass2 ? 'text' : 'password'"
                                :append-icon="showPassChangePass2 ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassChangePass2 = !showPassChangePass2"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </app-modal-container>    
            </v-form>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="modalPermission.show"
            :loading="modalPermission.loading"
            @confirm="confirmEditPermissionDialog()"
            @cancel="noEditPermissionDialog()"
        >
            <template #title>
                Editar Permiso
            </template>
            <v-form ref="editPermissionDialogForm" class="px-15 py-8">
                <app-modal-container>
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-select
                            v-model="modalPermission_selected"
                            filled
                            color="primary"
                            class="rounded-lg"
                            label="Permiso"
                            item-text="value"
                            item-value="name"
                            prepend-inner-icon="mdi-account-eye"
                            :items="permissions.itemsPermissions"
                            :rules="[validationRules.required]"
                        />
                        </app-modal-col>
                    </app-modal-row>
                </app-modal-container>
                
            </v-form>
        </app-modal-prompt>

        <app-page-card v-if="permission.general.can_admin">
            <template #header>
                {{title}}
            </template>
            <template #tabs-title>
                <div class="px-8 pt-2 tabs-title-div-bck">
                    <v-row align="center">
                        <v-col cols="12" class="pt-0">
                            <v-tabs v-model="tabUserScreen">
                                <v-tab :value="1">Usuarios</v-tab>
                                <v-tab :value="2">Permisos</v-tab>
                            </v-tabs>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template>
                <v-tabs-items v-model="tabUserScreen" class="ma-0 items-tabs">
                    <v-tab-item
                        key="Usuarios"
                    >
                        <app-container fluid>
                            <app-row>
                                <app-col cols="12">
                                    <data-table-with-api
                                        ref="usersTable"
                                        :headers="usersHeaders.filter(h => h.value !== 'view_working_hours' || (userData && userData.available_features && userData.available_features.feature_clock_in))"
                                        :url="'users_organization'"
                                        :footer-items-per-page-text="userItemsPerPageText"
                                        :showSelect="true"
                                        :hideHeaderCheckbox="true"
                                        :search-filters="userSearchFilters"
                                        :action-btn-list="usersActionBtnList"
                                        :disabledRowField="'disabled_row'"
                                        :disabledCheckRowField="'disabled_checkbox'"
                                        @click-col-action-btn="clickUserTableActionBtn"
                                        @selected-items-changed="selectedItemsUserChanged"
                                        >
                                        <!-- Botones derecha de buscador -->
                                        <template slot="search_right" >
                                            <div align="right">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn @click="refreshUsersList" color="primary" icon v-bind="attrs" v-on="on" :loading="usersLoading">
                                                            <v-icon>mdi-refresh</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Actualizar</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn @click="openCreateUserDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                                            <v-icon>mdi-account-plus</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Nuevo usuario</span>
                                                </v-tooltip>
                                                <JobProgress v-model="deleteUsersJobState" :job_id="deleteUsersAsyncJob" v-on:done="deleteUsersDone" v-on:error="deleteUsersError" divStyle="display: inline;">
                                                    <template v-slot:progress>
                                                        <v-progress-circular
                                                            indeterminate
                                                            class="mr-2"
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </template>
                                                    <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    :key="'btn_delete_users'+slotName"
                                                                    @click.stop="openDeleteConfirmUsersDialog()"
                                                                    :disabled="usersSelected.length==0"
                                                                    color="primary"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    icon >
                                                                    <v-icon>mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Desactivar usuarios</span>
                                                        </v-tooltip>
                                                    </template>
                                                </JobProgress>
                                            </div>
                                        </template>
                                        <template slot="friendship_kind" slot-scope="item">{{ item.friendship['kind_desc'] || 'Propietario' }}</template>
                                        <template slot="view_all_companies" slot-scope="item">{{ item.friendship['view_all_companies_desc'] }}</template>
                                        <template slot="default_role_kind" slot-scope="item">{{ item.friendship['default_role_kind_desc'] }}</template>
                                        
                                        <template slot="view_invoices" slot-scope="item">
                                            <span v-if="!permissionsAvailability.view_invoices.show">--</span>
                                            <span v-else>{{ (item.friendship['view_invoices'] || !item.friendship['kind_desc']) ? 'Si' : 'No' }}</span>
                                        </template>
                                        <template slot="view_banks" slot-scope="item">
                                            <span v-if="!permissionsAvailability.view_banks.show">--</span>
                                            <span v-else>{{ (item.friendship['view_banks'] || !item.friendship['kind_desc']) ? 'Si' : 'No' }}</span>
                                        </template>
                                        <template slot="view_e_invoice" slot-scope="item">
                                            <span v-if="canAccessEInvoice(item)">
                                                {{ item.friendship['view_e_invoice'] ? 'Si' : 'No' }}
                                            </span>
                                            <span v-else>--</span>
                                        </template>
                                        <template slot="view_gestor" slot-scope="item">
                                            <span v-if="!permissionsAvailability.view_gestor.show">--</span>
                                            <span v-else>{{ (item.friendship['view_gestor'] || !item.friendship['kind_desc']) ? 'Si' : 'No' }}</span>
                                        </template>
                                        <template slot="view_working_hours" slot-scope="item">
                                            <span v-if="!permissionsAvailability.view_working_hours.show">--</span>
                                            <span v-else>{{ (item.friendship['view_working_hours'] || !item.friendship['kind_desc']) ? 'Si' : 'No' }}</span>
                                        </template>
                                        <template slot="state" slot-scope="item">
                                            <template>{{item['state']['name']}}</template>
                                        </template>
                                    </data-table-with-api>
                                    <span v-if="showKitDigitalText()">{{this.permissions.headers.length}} usuarios creados de un máximo de 10</span>
                                </app-col>
                            </app-row>
                        </app-container>
                    </v-tab-item>
                    <v-tab-item
                        key="Permisos"
                    >
                        <app-container fluid>
                            <app-row>
                                <app-col>
                                    <data-table-with-api
                                        v-if="permissions.hasPermissions"
                                        ref="PermissionsTable"
                                        :headers="permissions.headers"
                                        :url="permissions.url"
                                        :search-filters="permissions.searchFilters"
                                        :footer-ttems-per-page-text="permissions.footerItemsPerPageText"
                                        :show-select="true"
                                        :hide-header-checkbox="true"
                                        class-name="permissions-table"
                                        @selected-items-changed="clickCompanyPermissions"
                                        @selected-cols-changed="selectedUserPermission"
                                        :mobile="true"
                                    >
                                    <!-- Botones derecha de buscador -->
                                    <template slot="search_right" >
                                        <v-row class="ma-0 pa-0" >
                                            <v-col cols="3" class="ma-0 pt-2 pr-0 pl-2 pb-0">
                                                <v-checkbox @change="clickCheckboxAllCompanies()"
                                                            hide-details
                                                            v-model="allCompanyiesCheckbox_selected"
                                                            class="ma-0 pa-0">
                                                    <template v-slot:label>
                                                        <b class="small-font">{{ allCompanyiesCheckbox.label }}</b>
                                                    </template>
                                                </v-checkbox>
                                            </v-col>
                                            <v-col cols="3" class="ma-0 pt-2 pr-0 pl-0 pb-0">
                                                <v-checkbox @change="clickCheckboxAllUsers()"
                                                            hide-details
                                                            v-model="allUsersCheckbox_selected"
                                                            class="ma-0 pa-0">
                                                    <template v-slot:label>
                                                        <b class="small-font">{{ allUsersCheckbox.label }}</b>
                                                    </template>
                                                </v-checkbox>
                                            </v-col>
                                            <v-col cols="6" class="ma-0 pa-0">
                                                <div align="right">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn @click="refreshPermissionsList()" 
                                                                   color="primary" 
                                                                   icon v-bind="attrs" 
                                                                   v-on="on" 
                                                                  :loading="permissions.loading">
                                                                <v-icon>mdi-refresh</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Actualizar</span>
                                                    </v-tooltip>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn color="primary"
                                                                   icon v-bind="attrs"
                                                                   v-on="on"
                                                                   :loading="permissions.loading"
                                                                   @click="openPermissionDialog()"
                                                            >
                                                                <v-icon>mdi-pencil-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Editar Permiso</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </data-table-with-api>
                                <div v-else>
                                    <v-row>
                                        <v-col>
                                            <p>El propietario no tiene usuarios creados y/o empresas configuradas.</p>
                                        </v-col>
                                    </v-row>
                                </div>
                                </app-col>
                            </app-row>

                        </app-container>
                    </v-tab-item>
                </v-tabs-items>
            </template>
        </app-page-card>
        
        <v-snackbar
            v-model="snackbar.isVisible"
            :color="snackbar.color"
        >
            <b>{{ snackbar.text }}</b>
        </v-snackbar>
    </div>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { client } from "@/api/client";
import TableListToolbar from '../components/TableListToolbar.vue';
import DataTableWithApi from '../components/DataTableWithApi.vue'
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import { mapFields, createHelpers } from 'vuex-map-fields';
import JobProgress from '../components/JobProgress.vue'
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import { DeleteUsersCommand } from "../modules/users/application/DeleteUsersCommand"
import validator from 'validator';
import { BlockUnblockUserCommand } from "../modules/users/application/BlockUnblockUserCommand"
import { UpdateFiscalDataUserCommand } from "../modules/users/application/UpdateFiscalDataUserCommand"
import { async_command_dispatcher} from "@/api/client";
import { sync_command_dispatcher} from "@/api/client";
import { MemoryServiceDeliveryRepo } from "@/modules/revenue/infra/MemoryServiceDeliveryRepo";
import { GetAccessViewAvailabilityQuery } from '@/modules/users/application/GetAccessViewAvailabilityQuery';
import WorkScheduleTable from '@/modules/working_hours/infra/WorkScheduleTable.vue';


export default {
    name: 'UsersPermissions',
    components: {
        TableListToolbar,
        DataTableWithApi,
        AppPageCard,
        AppModalPrompt,
        AppModalCol,
        AppModalContainer,
        AppModalRow,
        AppTextField,
        AppSelect,
        AppCol,
        AppRow,
        AppContainer,
        JobProgress,
        AppConfirmModal,
        WorkScheduleTable,
    },
    data() {
        return {
            title: 'Gestión de Usuarios',
            loading:false,
            search:"",
            textErrorApiEditPermission: 'Ha ocurrido un error al editar el permiso.',
            textAllCompanies: 'Todas las Empresas',
            textAllUsers: 'Todos los Usuarios',
            checkAllCompanies: false,
            checkAllUsers: false,
            showPassCreateUserDialog: false,
            showPassCreateUserDialog2: false,
            createUserDialog: false,
            createUserLoading: false,
            newUserValues: {
                username: '',
                email: '',
                password: '',
                password_repeat: '',
                friendship_kind: '',
                view_all_companies: false,
                view_invoices: true,
                view_banks: false,
                view_e_invoice: false,
                view_gestor: false,
                view_working_hours: false,
                default_role_kind: '',
                work_schedule: {
                    nombre_jornada: 'Jornada Completa',
                    vacation_days: 22,
                    horario_semanal: {
                        lunes: { hora_entrada: '09:00', hora_salida: '17:00' },
                        martes: { hora_entrada: '09:00', hora_salida: '17:00' },
                        miercoles: { hora_entrada: '09:00', hora_salida: '17:00' },
                        jueves: { hora_entrada: '09:00', hora_salida: '17:00' },
                        viernes: { hora_entrada: '09:00', hora_salida: '17:00' },
                        sabado: { hora_entrada: null, hora_salida: null },
                        domingo: { hora_entrada: null, hora_salida: null }
                    }
                },
            },
            tabUserScreen: 0,
            usersLoading: false,
            userItemsPerPageText: 'Usuarios por página:',
            userSearchFilters: ['text__icontains'],
            usersActionBtnList: [{'name': 'Bloquear Usuario', 'action': 'block_user', 'icon': 'mdi-cancel', 'show_field': 'show_block_btn'},
                                 {'name': 'Desbloquear Usuario', 'action': 'unblock_user', 'icon': 'mdi-check', 'show_field': 'show_unblock_btn'},
                                 {'name': 'Editar Usuario', 'action': 'update_user', 'icon': 'mdi-pencil-outline'},
                                 {'name': 'Editar Datos Fiscales', 'action': 'update_fiscal_data_user', 'icon': 'mdi-card-account-details-outline', 'show_field': 'show_update_fiscal_data_btn'},
                                 {'name': 'Cambiar Contraseña', 'action': 'update_password', 'icon': 'mdi-lock-reset'}
                                 ],
            textViewAllCompanies: 'Acceso por defecto a las empresas',
            usersHeaders: [
            {
                text: '',
                align: 'start',
                value: 'checkboxes',
                sortable: false,
            },
            {
                text: 'Nombre de usuario',
                sortable: true,
                value: 'username',
                width: '180'
            },
            {
                text: 'Email',
                value: 'email',
                sortable: true,
            },
            {
                text: 'Rol',
                value: 'friendship_kind',
                sortable: false
            },
            {
                text: 'Acceso por defecto a las empresas',
                value: 'view_all_companies',
                sortable: false
            },
            {
                text: 'Permiso por defecto',
                value: 'default_role_kind',
                sortable: false
            },
            {
                text: 'Acceso a facturas',
                value: 'view_invoices',
                sortable: false
            },
            {
                text: 'Acceso a bancos',
                value: 'view_banks',
                sortable: false
            },
            {
                text: 'Acceso a factura electrónica',
                value: 'view_e_invoice',
                sortable: false
            },
            {
                text: 'Acceso a gestor documental',
                value: 'view_gestor',
                sortable: false
            },
            {
                text: 'Acceso a fichajes',
                value: 'view_working_hours',
                sortable: false
            },
            {
                text: 'Última actividad',
                value: 'last_login',
                sortable: true,
            },
            {
                text: 'Estado',
                value: 'state',
                sortable: true,
            },
            {
                text: '',
                value: 'actions',
                width: '180',
                align: 'end',
                sortable: false,
            },
            ],
            changePassUserDialog: false,
            showPassChangePass: false,
            showPassChangePass2: false,
            newPassValues: {
                user_id: null,
                password: '',
                password_repeat: '',
            },
            changePassLoading: false,
            passMinLength: 8,
            updateUserDialog: false,
            updateUserLoading: false,
            updateUserValues: {
                user_id: null,
                username: '',
                email: '',
                kind: '',
                view_all_companies: false,
                default_role_kind: '',
                view_invoices: true,
                view_banks: false,
                view_e_invoice: false,
                view_gestor: false,
                view_working_hours: false,
            },
            updateFiscalDataUserDialog: false,
            updateFiscalDataUserLoading: false,
            updateFiscalDataUserValues: {
                user_id: null,
                business_name: '',
                business_id: '',
                postal_address: '',
                post_code: '',
                province: ''
            },
            blockUnblockUserValues: {
                user_id: null,
                blocked: null
            },
            textPassMinLength: 'Mínimo 8 carácteres',
            validationRules: {
                required: v => !!v || 'Campo obligatorio',
                passMinLength: v => v && v.length >= this.passMinLength || this.textPassMinLength,
                changePassEqRepeat: v => v == this.newPassValues.password || 'Las dos contraseñas deben ser iguales.',
                createUserPassEqRepeat: v => v == this.newUserValues.password || 'Las dos contraseñas deben ser iguales.',
                emailFormat: v => validator.isEmail(v || '') || 'El formato del email no es válido',
                requiredDefaultRoleKindCreate: v => (!!v || !this.newUserValues.view_all_companies) || 'Campo obligatorio',
                requiredDefaultRoleKindUpdate: v => (!!v || !this.updateUserValues.view_all_companies) || 'Campo obligatorio',
                notBlankSpace: v => (!!v && !v.includes(' ')) || 'Campo con espacios en blanco',
            },
            snackbar: {
                isVisible: false,
                text: '',
                color: 'error',
            },
            textSnackbarOk: 'Cambios realizados con éxito.',
            textSnackbarKo: 'Compruebe que los valores en el formulario son válidos.',
            textSnackbarKoApi: 'Ha habido un problema con la operación.',
            deleteUsersConfirmDialog: false,
            deleteUsersConfirmMsg: 'Se van a desactivar definitivamente los usuarios seleccionados.',
            deleteUsersLoading: false,
            usersSelected: [],
            deleteUsersAsyncJob: null,
            deleteUsersJobState: 'done',
            blockUserConfirmDialog: false,
            blockUserConfirmMsg: 'Se va a bloquear el usuario y no podrá iniciar sesión en Inmatic.',
            unblockUserConfirmDialog: false,
            unblockUserConfirmMsg: 'Se va a desbloquear el usuario y podrá volver a iniciar sesión en Inmatic.',
            permissionsAvailability: {
                view_invoices: { show: false, error: false },
                view_banks: { show: false, error: false },
                view_e_invoice: { show: false, error: false },
                view_gestor: { show: false, error: false },
                view_working_hours: { show: false, error: false },
            },
            permissionsLoadingPromise: null
        }
    },
    computed: {
        ...mapGetters({
            userData: 'me/userData',
            permission: 'permissions/permission',
            got_feature: 'got_feature',
            selectedCompanyiesIds: 'users_permissions/selectedCompanyiesIds',
            selectedUsersIds: 'users_permissions/selectedUsersIds',
        }),
        ...mapFields('users_permissions', {
            permissions: 'permissions',
            allUsersCheckbox: 'allUsersCheckbox',
            allUsersCheckbox_selected: 'allUsersCheckbox.selected',
            allCompanyiesCheckbox: 'allCompanyiesCheckbox',
            allCompanyiesCheckbox_selected: 'allCompanyiesCheckbox.selected',
            modalPermission: "modalPermission",
            modalPermission_selected: "modalPermission.selected",
        }),

    },
    methods: {
        ...mapActions({
            refreshUserData: "me/refreshUserData",
            textToLowerCase: "config/textToLowerCase",
            createCompanyDBUser: "connector/createCompanyDBUser",
            changePassCDBUser: "connector/changePassCDBUser",
            updateCompanyDBUser: "connector/updateCompanyDBUser",
            initPermissionsTable: "users_permissions/initPermissionsTable",
            setPermissionsLoading: "users_permissions/setPermissionsLoading",
            selectCheckboxAllCompanies: "users_permissions/selectCheckboxAllCompanies",
            selectCheckboxAllUsers: "users_permissions/selectCheckboxAllUsers",
            selectedCompanyPermission: "users_permissions/selectedCompanyPermission",
            closePermissionDialog: "users_permissions/closePermissionDialog",
            openPermissionDialog: "users_permissions/openPermissionDialog",
            setModalLoading: "users_permissions/setModalLoading",
            resetPermissionsTable: "users_permissions/resetPermissionsTable",
            selectedUserPermission: "users_permissions/selectedUserPermission"
        }),
        getDataPermissions() {
            this.initPermissionsTable();
        },
        clickCheckboxAllCompanies() {
            this.selectCheckboxAllCompanies(this.$refs['PermissionsTable']);
        },
        clickCheckboxAllUsers() {
            this.selectCheckboxAllUsers(this.$refs['PermissionsTable'])
        },
        clickCompanyPermissions(items, selected_all_items, search_params) {
            this.selectedCompanyPermission({ items: items, ref: this.$refs['PermissionsTable']});
        },
        updateListCheckbox(list, id) {
            const index = list.indexOf(id);
            if (index > -1) {
                list.splice(index, 1);
            }
            else {
                list.push(id);
            }
        },
        noEditPermissionDialog() {
            this.closePermissionDialog(this.$refs['PermissionsTable']);
        },
        confirmEditPermissionDialog() {
            this.setModalLoading(true);
            const formIsValid = this.$refs.editPermissionDialogForm.validate();
            if (formIsValid) {
                let params = {
                    companydb_ids: this.selectedCompanyiesIds,
                    user_ids: this.selectedUsersIds,
                    permission: this.modalPermission.selected
                };
                client.put('update_users_companydb_relation/', params).then((response) => {
                    if(response.data.hasOwnProperty("error")) {
                        this.setModalLoading(false);
                        this.setSnackbar('error', response.data['error']);
                        this.modalPermission.show = false;
                    }
                    else {
                        this.resetPermissionsTable(this.$refs['PermissionsTable']);
                        this.getDataPermissions();
                        this.refreshPermissionsList();
                        this.setModalLoading(false);
                        this.setSnackbar('success', this.textSnackbarOk);
                        this.modalPermission.show = false;
                    }
                }).catch(error => {
                    console.error(error);
                    this.setSnackbar('error', this.textSnackbarKoApi);
                    this.setModalLoading(false);
                });
            } else {
                this.setModalLoading(false);
                this.setSnackbar('error', this.textSnackbarKo);
            }
        },
        usernameToLowerCase() {
            this.textToLowerCase(this.newUserValues.username).then((res) => {
                this.newUserValues.username = res;
            }).catch(err => {
                console.error(err);
            });
        },
        async getAccessViewAvailability(userRole) {
            
            const featurePurchaseExtraUsers = this.userData && this.userData.available_features && this.userData.available_features['feature_purchase_extra_users']
            
            if (featurePurchaseExtraUsers){

                const getAccessViewAvailabilityQuery = new GetAccessViewAvailabilityQuery(this.sd_repo, this.permissionsAvailability);

                try {
                    await getAccessViewAvailabilityQuery.execute(userRole);
                } catch (err) {
                    console.error('Error al obtener permisos:', err);
                }
                
            } else {

                Object.keys(this.permissionsAvailability).forEach(key => {
                    this.permissionsAvailability[key].show = true;
                });
            }
        },
        async openCreateUserDialog() {
            this.resetModalCreateUserValues();
            await this.getAccessViewAvailability(this.newUserValues.friendship_kind);
            this.createUserDialog = true;

        },
        resetModalCreateUserValues() {
            this.newUserValues.username = '';
            this.newUserValues.email = '';
            this.newUserValues.password = '';
            this.newUserValues.password_repeat = '';
            this.newUserValues.friendship_kind = '';
            this.newUserValues.view_all_companies = false;
            this.newUserValues.view_invoices = true;
            this.newUserValues.view_banks = false;
            this.newUserValues.view_e_invoice = false;
            this.newUserValues.view_gestor = false;
            this.newUserValues.view_working_hours = false;
            this.newUserValues.default_role_kind = '';
            this.newUserValues.work_schedule = {
                nombre_jornada: 'Jornada Completa',
                vacation_days: 22,
                horario_semanal: {
                    lunes: { hora_entrada: '09:00', hora_salida: '17:00' },
                    martes: { hora_entrada: '09:00', hora_salida: '17:00' },
                    miercoles: { hora_entrada: '09:00', hora_salida: '17:00' },
                    jueves: { hora_entrada: '09:00', hora_salida: '17:00' },
                    viernes: { hora_entrada: '09:00', hora_salida: '17:00' },
                    sabado: { hora_entrada: null, hora_salida: null },
                    domingo: { hora_entrada: null, hora_salida: null }
                }
            };
            this.showPassCreateUserDialog = false;
            this.showPassCreateUserDialog2 = false;
        },
        confirmCreateUser() {
            this.createUserLoading = true;
            const formIsValid = this.$refs.createUserDialogForm.validate();
            if (formIsValid) {
                // Validar horario si tiene acceso a fichajes
                if (this.newUserValues.view_working_hours && this.$refs.scheduleTable && !this.$refs.scheduleTable.validate()) {
                    this.setSnackbar('error', 'Por favor complete correctamente el horario de trabajo');
                    this.createUserLoading = false;
                    return;
                }
                this.createCompanyDBUser(this.newUserValues).then(async (response) => {
                    if(response.data.hasOwnProperty("error")) {
                        this.setSnackbar('error', response.data['error']);
                        this.createUserLoading = false;
                    }
                    else {
                        // Si tiene acceso a fichajes, actualizar el work schedule creado por la señal
                        if (this.newUserValues.view_working_hours && response.data.user_id) {
                            try {
                                await sync_command_dispatcher.dispatch('update_work_schedule_by_user.command', {
                                    user_id: response.data.user_id,
                                    nombre_jornada: this.newUserValues.work_schedule.nombre_jornada,
                                    vacation_days: this.newUserValues.work_schedule.vacation_days,
                                    horario_semanal: this.newUserValues.work_schedule.horario_semanal
                                });
                            } catch (err) {
                                console.error('Error updating work schedule:', err);
                            }
                        }
                        this.createUserDialog = false;
                        this.createUserLoading = false;
                        this.setSnackbar('success', this.textSnackbarOk);
                        this.resetModalCreateUserValues();
                        this.refreshUsersList();
                        this.getDataPermissions();
                    }
                }).catch(error => {
                    console.error(error);
                    this.setSnackbar('error', this.textSnackbarKoApi);
                    this.createUserLoading = false;
                });
            } else {
                this.setSnackbar('error', this.textSnackbarKo);
                this.createUserLoading = false;
            }
        },
        cancelCreateUser() {
            this.createUserDialog = false;
            this.resetModalCreateUserValues();
        },

        confirmBlockUser() {
            let user_to_update_id = this.blockUnblockUserValues.user_id;
            let blocked = this.blockUnblockUserValues.blocked;
            new BlockUnblockUserCommand(sync_command_dispatcher, this).run(user_to_update_id, blocked).then(response => {
                this.blockUserConfirmDialog = false;
                this.resetBlockUnblockUserDialog();
                this.refreshUsersList();
                this.setSnackbar('success', this.textSnackbarOk);
            }).catch(error => {
                console.error(error);
                this.setSnackbar('error', this.textSnackbarKoApi);
            });
        },

        cancelBlockUser() {
            this.resetBlockUnblockUserDialog();
            this.blockUserConfirmDialog = false;
        },

        confirmUnblockUser() {
            let user_to_update_id = this.blockUnblockUserValues.user_id;
            let blocked = this.blockUnblockUserValues.blocked;
            new BlockUnblockUserCommand(sync_command_dispatcher, this).run(user_to_update_id, blocked).then(response => {
                this.unblockUserConfirmDialog = false;
                this.resetBlockUnblockUserDialog();
                this.refreshUsersList();
                this.setSnackbar('success', this.textSnackbarOk);
            }).catch(error => {
                console.error(error);
                this.setSnackbar('error', this.textSnackbarKoApi);
            });
        },

        cancelUnblockUser() {
            this.resetBlockUnblockUserDialog();
            this.unblockUserConfirmDialog = false;
        },

        resetBlockUnblockUserDialog() {
            this.blockUnblockUserValues.user_id = null;
            this.blockUnblockUserValues.blocked = null;
        },

        openDeleteConfirmUsersDialog() {
            this.deleteUsersConfirmDialog = true;
        },

        async confirmDeleteUsers() {
            let user_ids = this.usersSelected;
            let response = await new DeleteUsersCommand(async_command_dispatcher, this).run(user_ids);
            this.deleteUsersAsyncJob = response['job_id'];
            this.deleteUsersJobState = 'running';
            this.usersSelected = [];
            this.deleteUsersConfirmDialog = false;
        },

        cancelDeleteUsers() {
            this.deleteUsersConfirmDialog = false;
        },

        deleteUsersDone() {
            this.setSnackbar('success', this.textSnackbarOk);
            this.refreshUsersList();
            this.getDataPermissions();
        },

        deleteUsersError() {
            this.usersSelected = [];
            this.refreshUsersList();
            this.setSnackbar('error', this.textSnackbarKoApi);
            console.error('Error Async Job Id', this.deleteUsersAsyncJob)
        },

        selectedItemsUserChanged(items, selected_all_items, search_params) {
            this.usersSelected = [];
            this.usersSelected = items.map(function(item) {
                    return item['id'];
            });
        },

        refreshPermissionsList() {
            if (this.$refs.PermissionsTable) { 
                this.setPermissionsLoading(true);
                this.$refs.PermissionsTable.getItems().then((res) => {
                    this.setPermissionsLoading(false);
                }).catch(err => {
                    this.setPermissionsLoading(false);
                });
            }
        },
        refreshUsersList() {
            if (this.$refs.usersTable) {
                this.usersLoading = true;
                this.$refs.usersTable.getItems().then((res) => {
                    this.usersLoading = false;
                }).catch(err=>{
                    console.error(err)
                });
            }
        },
        showKitDigitalText() {
            if (this.got_feature('feature_kit_digital') && this.permissions.headers.length > 0 && this.permissions.headers.length <= 10) {
                return true;
            }
            return false;
        },
        async clickUserTableActionBtn(action, item) {
            if (action == 'update_password') {
                if (this.$refs && this.$refs.changePassUserDialogForm) {
                    this.$refs.changePassUserDialogForm.reset();
                }
                this.newPassValues.user_id = item.id;
                this.changePassUserDialog = true;
            }
            if (action == 'update_user') {
                this.updateUserValues.user_id = item.id;
                this.updateUserValues.userame = item.username;
                this.updateUserValues.email = item.email;
                this.updateUserValues.kind = item.friendship['kind'];
                this.updateUserValues.view_all_companies = item.friendship['view_all_companies'];
                this.updateUserValues.default_role_kind = item.friendship['default_role_kind'] || '';
                this.updateUserValues.view_invoices = item.friendship['view_invoices'];
                this.updateUserValues.view_banks = item.friendship['view_banks'];
                this.updateUserValues.view_e_invoice = item.friendship['view_e_invoice'];
                this.updateUserValues.view_gestor = item.friendship['view_gestor'];
                this.updateUserValues.view_working_hours = item.friendship['view_working_hours'];
                await this.getAccessViewAvailability(this.updateUserValues.kind)
                this.updateUserDialog = true;
            }
            if (action == 'block_user') {
                this.blockUnblockUserValues.user_id = item.id;
                this.blockUnblockUserValues.blocked = true;
                this.blockUserConfirmDialog = true;
            }
            if (action == 'unblock_user') {
                this.blockUnblockUserValues.user_id = item.id;
                this.blockUnblockUserValues.blocked = false;
                this.unblockUserConfirmDialog = true;
            }
            if (action == 'update_fiscal_data_user') {
                this.updateFiscalDataUserValues.user_id = item.id;
                this.updateFiscalDataUserValues.business_name = item.business_name
                this.updateFiscalDataUserValues.business_id = item.business_id
                this.updateFiscalDataUserValues.postal_address = item.postal_address
                this.updateFiscalDataUserValues.post_code = item.post_code
                this.updateFiscalDataUserValues.province = item.province
                this.updateFiscalDataUserDialog = true;
            }
        },
        resetChangePassUserDialog() {
            this.newPassValues.user_id = null;
            this.newPassValues.password = '';
            this.newPassValues.password_repeat = '';
            this.showPassChangePass = false;
            this.showPassChangePass2 = false;
            this.setSnackbar('', '');
        },
        cancelChangePassUserDialog() {
            this.changePassUserDialog = false;
            this.resetChangePassUserDialog();
        },
        confirmChangePassUserDialog() {
            this.changePassLoading = true;
            const formIsValid = this.$refs.changePassUserDialogForm.validate();
            if (formIsValid) {
                this.changePassCDBUser({user_id: this.newPassValues.user_id, pass: this.newPassValues.password}).then(response => {
                    this.changePassUserDialog = false;
                    this.resetChangePassUserDialog();
                    this.changePassLoading = false;
                    this.setSnackbar('success', this.textSnackbarOk);
                }).catch(error => {
                    console.error(error);
                    this.setSnackbar('error', this.textSnackbarKoApi);
                    this.changePassLoading = false;
                });
            } else {
                this.changePassLoading = false;
                this.setSnackbar('error', this.textSnackbarKo);
            }
        },
        cancelUpdateUserDialog() {
            this.updateUserDialog = false;
            this.setSnackbar('', '');
        },
        confirmUpdateUserDialog() {
            this.updateUserLoading = true;

            const formIsValid = this.$refs.updateUserDialogForm.validate();
            if (formIsValid) {
                this.updateCompanyDBUser(this.updateUserValues).then(response => {
                    if(response.data.hasOwnProperty("error")) {
                        this.setSnackbar('error', response.data['error']);
                        this.updateUserLoading = false;
                    }
                    else {
                        this.updateUserDialog = false;
                        this.updateUserLoading = false;
                        this.setSnackbar('success', this.textSnackbarOk);
                        this.refreshUsersList();
                        this.getDataPermissions();
                    }
                }).catch(error => {
                    console.error(error);
                    this.setSnackbar('error', this.textSnackbarKoApi);
                    this.updateUserLoading = false;
                });
            } else {
                this.updateUserLoading = false;
                this.setSnackbar('error', this.textSnackbarKo);
            }
        },
        cancelUpdateFiscalDataUserDialog() {
            this.updateFiscalDataUserDialog = false;
            this.setSnackbar('', '');
        },
        resetUpdateFiscalDataUserDialog() {
            this.updateFiscalDataUserValues.user_id = null;
            this.updateFiscalDataUserValues.business_name = '';
            this.updateFiscalDataUserValues.business_id = '';
            this.updateFiscalDataUserValues.postal_address = '';
            this.updateFiscalDataUserValues.post_code = '';
            this.updateFiscalDataUserValues.province = '';
        },
        confirmUpdateFiscalDataUserDialog() {
            this.updateFiscalDataUserLoading = true;
            new UpdateFiscalDataUserCommand(sync_command_dispatcher, this).run(this.updateFiscalDataUserValues.user_id, this.updateFiscalDataUserValues.business_name, this.updateFiscalDataUserValues.business_id, this.updateFiscalDataUserValues.postal_address, this.updateFiscalDataUserValues.post_code, this.updateFiscalDataUserValues.province).then(response => {
                this.updateFiscalDataUserDialog = false;
                this.resetUpdateFiscalDataUserDialog();
                this.refreshUsersList();
                this.setSnackbar('success', this.textSnackbarOk);
            }).catch(error => {
                console.error(error);
                this.setSnackbar('error', this.textSnackbarKoApi);
            });
            this.updateFiscalDataUserLoading = false;
        },
        setSnackbar(color, text) {
            if (text != '') {
                this.snackbar.text = text;
                this.snackbar.isVisible = true;
                this.snackbar.color = color;
            }
            else {
                this.snackbar.text = '';
                this.snackbar.isVisible = false;
            }
        },
        defaultRoleKindSelectItems(modal) {
            let friendship_kind = '';
            let customer_writer = false; //Para poder editar usuarios que ya tienen esta configuración guardada.
            if (modal == 'create_user') {
                friendship_kind = this.newUserValues.friendship_kind;
            }
            else if (modal == 'update_user') {
                friendship_kind = this.updateUserValues.kind;
                customer_writer = this.updateUserValues.default_role_kind == 'writer';
            }
            let items = [{name: 'Lectura', value: 'read_only'}];
            if (friendship_kind && ((friendship_kind != 'customer' && friendship_kind != 'customer_consult') || customer_writer)) {
                items.push({name: 'Escritura', value: 'writer'});
            }
            return items;
        },
        clearNewUserDefaultRoleKind() {
            this.newUserValues.default_role_kind = '';
            if (this.newUserValues.friendship_kind == 'customer') {
                this.newUserValues.view_all_companies = false;
            }
        },
        async onNewUserRoleChange() {
            this.clearNewUserDefaultRoleKind();
            await this.getAccessViewAvailability(this.newUserValues.friendship_kind);
        },
        changeUpdateUserKind() {
            if (this.updateUserValues.kind == 'customer') {
                this.updateUserValues.view_all_companies = false;
                this.updateUserValues.default_role_kind = '';
            } else {
                this.updateUserValues.view_e_invoice = false;
            }
        },
        async onUpdateUserRoleChange() {
            this.changeUpdateUserKind();
        },
        canAccessEInvoice(item) {

            if (!item || !item.friendship) {
                console.error('Invalid item or missing friendship data:', item);
                return false;
            }

            const isCustomerUser = (item.friendship['kind'] === 'customer');

            return isCustomerUser || false;
        },
    },
    mounted(){
        this.getDataPermissions();
    },
    async created(){

        this.sd_repo = new MemoryServiceDeliveryRepo(this.userData.all_contracts);

        await this.getAccessViewAvailability(null);
        
    }
}
</script>
<style scoped>
    .small-font {
        font-size: 12px;
    }
    .modalCheckBox {
        margin-top: -4px;
        padding-top: 0px;
        margin-bottom: 4px;
    }
    ::v-deep .v-tabs-bar__content {
        background: #F8F8FA;
    }
    .v-tab {
        text-transform: capitalize !important;
        font-weight: 400; 
        font-size: 18px;
    }
    ::v-deep .permissions-table > div > table > tbody > tr > td:nth-child(1),
    ::v-deep .permissions-table > div > table > thead > tr > th:nth-child(1),
    ::v-deep .permissions-table > div > table > tbody > tr > td:nth-child(2),
    ::v-deep .permissions-table > div > table > thead > tr > th:nth-child(2) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        z-index: 3;
        background-color: #FFFFFF;
    }
    ::v-deep .permissions-table > div > table > tbody > tr:nth-of-type(even) > td:nth-child(1),
    ::v-deep .permissions-table > div > table > thead > tr:nth-of-type(even) > th:nth-child(1),
    ::v-deep .permissions-table > div > table > tbody > tr:nth-of-type(even) > td:nth-child(2),
    ::v-deep .permissions-table > div > table > thead > tr:nth-of-type(even) > th:nth-child(2) {
        background-color: rgba(250, 250, 250, 1);
    }

    ::v-deep .permissions-table > div > table > tbody > tr:hover > td:nth-child(1),
    ::v-deep .permissions-table > div > table > thead > tr:hover > th:nth-child(1),
    ::v-deep .permissions-table > div > table > tbody > tr:hover > td:nth-child(2),
    ::v-deep .permissions-table > div > table > thead > tr:hover > th:nth-child(2) {
        background-color: #eeeeee;
    } 
    ::v-deep .permissions-table > div > table > thead > tr > th:nth-child(1),
    ::v-deep .permissions-table > div > table > thead > tr > th:nth-child(2) {
        z-index: 4;
    }
    
</style>